import { GetOrderStatusBarTypeProps } from '../../OrderLayout/OrderStatusBar/types'

export const getQuoteOrderStatusBarType = ({element, elementNext, parsedKey, currentOrderStatus, statusesLength, isCanceledBar}: GetOrderStatusBarTypeProps) => {
    const id = element.id
    let type = currentOrderStatus > id ? 'completed_status' : currentOrderStatus === id ? 'actual_status' : 'future_status'
    let isLast = true
    if (elementNext) {
        const futureType = currentOrderStatus > elementNext.id ? 'completed_status' : currentOrderStatus === elementNext.id ? 'actual_status' : 'future_status'
        isLast = futureType !== type
        if (statusesLength === parsedKey + 2 && futureType === 'actual_status') {
            isLast = false
        }
    } else if (type === 'actual_status') {
        type = 'last_actual_status'
    }
    if (isCanceledBar) {
        type = 'canceled_' + type
    }
    if (id === 6) {
        type = 'old_version'
    }
    return {type, isLast}
}

